export const useInstallationName = (str, installationName) => {
  if (str && installationName) {
    return str.replace(/Clinicdesk/g, installationName);
  }
  return str;
};

export default {
  methods: {
    useInstallationName,
  },
};
